<template>
  <v-row
    id="user-profile-wrapper"
    class="d-flex my-8"
    justify="center"
    no-gutters
  >
    <v-col cols="12" lg="10" md="10">
      <card-widget height="375px">
        <template #cardBody>
          <loader :loading="isLoading" :size="$appConfig.loader.small" />
          <h5
            class="text-h6 secondary--font font-weight-large text--primary pb-6"
          >
            {{ $dictionary.app.manageUsers.user.title }}
          </h5>

          <div id="user-profile-information" class="pt-4">
            <user-content name="Login ID" :value="capitalize(user.email)" />
            <user-content
              name="First Name"
              :value="capitalize(user.first_name)"
            />
            <user-content
              name="Last Name"
              :value="capitalize(user.last_name)"
            />
            <user-content
              name="Created At"
              :value="formatDateToAmPm(user.created_at)"
            />
            <user-content
              :divider="false"
              name="Updated At"
              :value="formatDateToAmPm(user.updated_at)"
            />
          </div>
        </template> </card-widget
    ></v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import UserContent from "./UserContent.vue";
import { CardWidget } from "@/components/widgets";

import { capitalize, formatDateToAmPm } from "@/filters";

/**
 * Show user details
 */
export default {
  name: "UserDetails",
  /**
   * ---------------- Props ------------------
   */
  props: {
    user: { type: Object, required: true, default: () => ({}) },
    isLoading: { type: Boolean, required: true, default: false },
  },
  /**
   * ---------------- Components ------------------
   */
  components: {
    CardWidget,
    UserContent,
  },
  /**
   * ---------------- Data Properties ------------------
   */
  data() {
    const { snackbarTypes } = this.$appConfig.snackbar;

    return {
      snackbarTypes,
      areInputFieldsDisabled: true,
    };
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    capitalize,
    formatDateToAmPm,
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
  },
};
</script>
